import convert from 'xml-js';

import { RSSResponse } from './typing';

export const fetchRSS = async (): Promise<RSSResponse | undefined> => {
  const response = await fetch('https://blog.localstack.cloud/rss.xml');
  if (!response.ok) {
    return;
  }
  const xmlTest = await response.text();
  return convert.xml2js(xmlTest, { compact: true }) as RSSResponse;
};
